import React from 'react';

class TestErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 max-w-4xl mx-auto bg-red-50 border border-red-200 rounded-lg">
          <h1 className="text-2xl font-bold text-red-800 mb-4">🚨 Errore nel Test Calendar Hook</h1>
          <div className="bg-white p-4 rounded border">
            <h2 className="text-lg font-semibold text-red-700 mb-2">Dettagli Errore:</h2>
            <pre className="text-sm text-red-600 whitespace-pre-wrap">
              {this.state.error ? this.state.error.toString() : 'Errore sconosciuto'}
            </pre>
            {this.state.errorInfo && this.state.errorInfo.componentStack && (
              <details className="mt-4">
                <summary className="cursor-pointer text-red-700 font-medium">Stack Trace</summary>
                <pre className="text-xs text-gray-600 mt-2 whitespace-pre-wrap">
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
          <button 
            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            🔄 Riprova Test
          </button>
          
          <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
            <h3 className="text-yellow-800 font-medium">💡 Suggerimenti per il debug:</h3>
            <ul className="text-sm text-yellow-700 mt-2 list-disc list-inside">
              <li>Verifica che il backend sia avviato e raggiungibile</li>
              <li>Controlla la console del browser per errori di rete</li>
              <li>Assicurati che le tabelle del database siano popolate</li>
              <li>Verifica che le API endpoints del calendario esistano</li>
            </ul>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default TestErrorBoundary;